/**
 * FAQ page walkthrough steps (uses shared IsfPageTour UI).
 * Targets must match data-tour attributes on FAQ.jsx.
 * Order: FAQ features first; AQ Assist last.
 */
export function buildFaqPageTourSteps(context = {}) {
  const {
    hasTopics = false,
    hasQuestions = false,
    hasRecent = false,
    hasUserGuides = false,
  } = context;

  const steps = [
    {
      id: "welcome",
      placement: "center",
      title: "Welcome to FAQ",
      body: "Browse topics, search questions, open user guides, and use Recent to jump back. Reopen this walkthrough anytime from Guide.",
    },
    {
      id: "guide-button",
      target: '[data-tour="faq-page-guide"]',
      placement: "bottom",
      title: "Page guide",
      body: "Click Guide whenever you want this FAQ walkthrough again.",
    },
    {
      id: "topics",
      target: '[data-tour="faq-topics"]',
      placement: "right",
      title: "Topics",
      body: "Browse modules your organisation can access. Expand a topic to pick a sub-section, or select the module name to see all questions for that topic.",
      when: () => hasTopics,
    },
    {
      id: "search",
      target: '[data-tour="faq-search"]',
      placement: "bottom",
      title: "Search",
      body: "Search questions and keywords. With a topic selected, search is scoped to that module.",
    },
    {
      id: "questions",
      target: '[data-tour="faq-questions"]',
      placement: "left",
      title: "Questions & answers",
      body: "Open a question to read the answer and watch a guide video when available. Expanding one question collapses the previous one.",
      when: () => hasQuestions,
    },
    {
      id: "recent",
      target: '[data-tour="faq-recent"]',
      placement: "left",
      title: "Recent",
      body: "Jump back to FAQs you opened or questions you asked in AQ Assist.",
      when: () => hasRecent,
    },
    {
      id: "user-guides-rail",
      target: '[data-tour="faq-user-guides"]',
      placement: "left",
      title: "User guides",
      body: "Open module user guides licensed for your organisation. Each guide opens in the centre panel.",
      when: () => hasUserGuides,
    },
    {
      id: "aq-assist",
      target: '[data-tour="faq-aq-assist"]',
      placement: "bottom",
      title: "AQ Assist",
      body: "AQ Assist is AI-enabled help for AQ Trials. Ask a how-to question and get a live response. Open it when you want guided answers in a chat.",
    },
    {
      id: "done",
      placement: "center",
      title: "You are ready",
      body: "Use Topics and Search for FAQ answers, User guides for PDFs, and AQ Assist when you want live AI help. Use Guide anytime for a refresher.",
    },
  ];

  return steps.filter((step) => (step.when ? step.when(context) : true));
}
